/**
 * Single source of truth for the public canonical host.
 *
 * Google ha elegido el apex como canónica y Vercel redirige `www` → apex,
 * así que todo el SEO (canonical, og:url, hreflang, JSON-LD, sitemaps)
 * debe emitir exactamente este host.
 *
 * Nota interna: vuelta a la versión del 5 de septiembre (12:39). Este comentario
 * solo existe para que la vuelta atrás genere un cambio que llegue a GitHub y
 * Vercel republique esa versión. No afecta a nada del comportamiento.
 */
export const SITE_URL = "https://retaillemon.com";
